module.exports = __webpack_public_path__ + "7d6b94add23aae1e9b664d5c8ee5512f.gif";